function updateFirstAndLastSlidePosition(swiperSliderConfig) {
    const swiperInstance = swiperSliderConfig.slider;
    const swiperWrapper = swiperSliderConfig.elem.find('.swiper-wrapper')[0];

    if (swiperInstance.activeIndex === 0) {
        swiperWrapper.style.transform = 'translate3d(0, 0, 0)';
    }

    if (swiperInstance.activeIndex === swiperInstance.slides.length - 1) {
        swiperWrapper.style.transform = `translate3d(-${swiperInstance.virtualSize - swiperInstance.width}px, 0, 0)`;
    }
}

function updateSliderNavigation(swiperSliderConfig) {
    document.querySelectorAll('.js-showroom-branch-nav-item').forEach((item) => {
        item.classList.remove('is-active')
    });

    const activeNavItemEl = document.querySelector(`.js-showroom-branch-nav-item:nth-child(${swiperSliderConfig.slider.activeIndex + 1})`)

    activeNavItemEl.classList.add('is-active');
}

const swipers = {
    hero: {
        slider: false,
        elem: $('.js-showroom-hero-image-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            simulateTouch: false,
            loop: false,
            effect: 'fade',
            pagination: {
                el: '.js-showroom-hero-image-slider-dots',
                clickable: true
            },
            autoplay: {
                delay: 4500,
                disableOnInteraction: false
            },
            on: {
                init: function () {
                    swipers.hero.active = true;
                }
            }
        }
    },
    branches: {
        slider: false,
        elem: $('.js-showroom-branches-slider'),
        options: {
            loop: false,
            centeredSlides: true,
            slidesPerView: 1.48,
            spaceBetween: 16,
            breakpoints: {
                599: {
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                },
                1023: {
                    slidesPerView: 1.1,
                }
            },
            autoplay: {
                delay: 4500
            },
            on: {
                init: function () {
                    swipers.branches.active = true;
                    updateFirstAndLastSlidePosition(swipers.branches);
                    updateSliderNavigation(swipers.branches);

                    document.querySelectorAll('.js-showroom-branch-nav-item').forEach((item, index) => {
                        item.addEventListener('click', () => {
                            swipers.branches.slider.slideTo(index);
                        });
                    });
                },
                transitionStart: function() {
                    updateFirstAndLastSlidePosition(swipers.branches);
                    updateSliderNavigation(swipers.branches);
                },
                transitionEnd: function() {
                    updateFirstAndLastSlidePosition(swipers.branches);
                    updateSliderNavigation(swipers.branches);
                },
                slideChange: function() {
                    updateFirstAndLastSlidePosition(swipers.branches);
                    updateSliderNavigation(swipers.branches);
                },
                imagesReady: function() {
                    updateFirstAndLastSlidePosition(swipers.branches);
                    updateSliderNavigation(swipers.branches);
                },
            }
        }
    },
    services: {
        slider: false,
        elem: $('.js-showroom-services-slider'),
        options: {
            loop: false,
            slidesPerView: 3,
            spaceBetween: 30,
            breakpoints: {
                599: {
                    slidesPerView: 1,
                },
                1023: {
                    slidesPerView: 2,
                }
            },
            navigation: {
                nextEl: '.js-showroom-services-slider .js-nav-item.is-next',
                prevEl: '.js-showroom-services-slider .js-nav-item.is-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            // autoplay: {
            //     delay: 4500
            // },
            on: {
                init: function () {
                    swipers.services.active = true;
                },
            }
        }
    },
    manufacturers: {
        slider: false,
        elem: $('.js-manufacturers-slider').eq(0),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 24,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            autoplay: {
                delay: 4500
            },
            pagination: {
                el: $('.js-manufacturers-slider-dots').eq(0),
                clickable: true
            },
            breakpoints: {
                599: {
                    spaceBetween: 15,
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                767: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                },
                1023: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                }
            },
            on: {
                init: function () {
                    swipers.manufacturers.active = true;
                },
                slideChange: function() {
                    setTimeout(function() {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    },
    manufacturers2: {
        slider: false,
        elem: $('.js-manufacturers-slider').eq(1),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 24,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            autoplay: {
                delay: 4500
            },
            pagination: {
                el: $('.js-manufacturers-slider-dots').eq(1),
                clickable: true
            },
            breakpoints: {
                599: {
                    spaceBetween: 15,
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                767: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                },
                1023: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                }
            },
            on: {
                init: function () {
                    swipers.manufacturers2.active = true;
                },
                slideChange: function() {
                    setTimeout(function() {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    },
    news: {
        slider: false,
        elem: $('.js-index-news-slider'),
        active: false,
        query: false,
        tooltipOpen: false,
        options: {
            loop: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: 13,
            simulateTouch: false,
            speed: 400,
            watchOverflow: true,
            roundLengths: true,
            pagination: {
                el: '.js-index-news-slider-dots',
                clickable: true
            },
            navigation: {
                nextEl: '.js-index-news-slider-next',
                prevEl: '.js-index-news-slider-prev',
                disabledClass: 'is-disabled',
                hiddenClass: 'is-hidden'
            },
            breakpoints: {
                359: {
                    spaceBetween: 6,
                    slidesPerView: 1.2,
                    slidesPerGroup: 1
                },
                599: {
                    spaceBetween: 10,
                    slidesPerView: 1.4,
                    slidesPerGroup: 1
                },
                767: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                1023: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                }
            },
            on: {
                init: function () {
                    swipers.news.active = true;
                },
                slideChange: function() {
                    setTimeout(function() {
                        bLazy.revalidate()
                    }, 300);
                }
            }
        }
    },
};

rEvent.on('Window.resized', function() {
    checkSliders(swipers);
});

function initLightGallery() {
    const $wrapper = $('.js-lightbox-wrapper');

    $wrapper.lightGallery($.extend({}, lightGallerySettings, {
        thumbnail: true,
        selector: '.swiper-slide:not(.swiper-slide-duplicate) .js-lightbox',
        exThumbImage: 'data-thumb',
        galleryId: 1
    }));
}

$(function() {
    checkSliders(swipers);
    initLightGallery();

    $('.js-gallery-more').off('click').on('click', function (e) {
        e.preventDefault();

        const lightboxLink = $('.js-lightbox-wrapper .showroom-banner__holder').find('.js-lightbox')[0];

        if (lightboxLink && lightboxLink !== e.target) {
            lightboxLink.click(); // Use native click to avoid triggering jQuery event handlers
        }
    });
    function checkVideoVisibility() {
        const video = document.querySelector('.c-showroom-hero video');
        if (!video) return;

        const rect = video.getBoundingClientRect();
        const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        const videoHeight = rect.bottom - rect.top;

        const isVisible = (
            rect.top < windowHeight &&
            rect.bottom > 0 &&
            videoHeight > 0
        );

        if (isVisible) {
            video.play().catch(() => {});
        } else {
            video.pause();
        }
    }

    window.addEventListener('scroll', checkVideoVisibility);
    window.addEventListener('resize', checkVideoVisibility);

    checkVideoVisibility();
});
